<div class="flex flex-col h-screen w-full bg-gray-100 overflow-hidden font-sans">
  
  <!-- 🛠️ TOP HEADER -->
  <header class="h-14 bg-[#006269] text-white flex items-center justify-between px-6 shadow-md shrink-0 z-5">
    <div class="flex items-center gap-3">
      <div class="bg-white/20 p-1.5 rounded-lg"><i class="fas fa-file-invoice-dollar text-cyan-300"></i></div>
      <h2 class="font-bold text-sm tracking-wide uppercase leading-none hidden sm:block">Meena Silver & Co</h2>
    </div>

    <div class="flex items-center gap-4">
      <!-- SEARCH BOX -->
      <div class="relative w-48 lg:w-96">
        <i class="fas fa-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-[10px]"></i>
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search Name, Inv, PAN..." 
               class="w-full bg-white/10 border border-white/20 rounded-lg py-2 pl-10 pr-4 text-xs text-white placeholder:text-white/40 outline-none focus:bg-white/20 focus:border-cyan-400 transition-all">
      </div>

      <button (click)="exportToExcel()" class="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-lg text-xs font-bold flex items-center gap-2 shadow-lg shrink-0">
        <i class="fas fa-file-excel"></i> <span>Export Excel</span>
      </button>
    </div>
  </header>

  <main class="flex-1 overflow-y-auto p-4 lg:p-6 space-y-4 custom-scrollbar">
    
    <!-- 📊 TOTAL SUMMARY CARDS -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 shrink-0">
      
      <!-- CARD 1: TOTAL AMOUNT -->
      <div class="bg-[#006269] rounded-2xl p-5 text-white shadow-lg relative overflow-hidden">
        <p class="text-[10px] opacity-70 uppercase font-black tracking-widest mb-1 text-cyan-200">Filtered Grand Total</p>
        <h3 class="text-3xl font-black">₹ {{ totalGrandSum | number:'1.2-2' }}</h3>
        <i class="fas fa-wallet absolute -right-4 -bottom-4 text-6xl opacity-10 rotate-12"></i>
      </div>

      <!-- CARD 2: TOTAL COUNT -->
      <div class="bg-white rounded-2xl p-5 border border-gray-200 shadow-sm flex items-center justify-between">
        <div>
          <p class="text-[10px] text-gray-400 uppercase font-black tracking-widest mb-1">Filtered Invoice Count</p>
          <h3 class="text-2xl font-black text-gray-800">{{ totalItems }}</h3>
        </div>
        <div class="bg-gray-100 p-3 rounded-xl text-gray-400">
            <i class="fas fa-file-invoice"></i>
        </div>
      </div>

      <!-- CARD 3: DATE FILTERS (New Location) -->
      <div class="bg-white rounded-2xl p-3 border border-gray-200 shadow-sm flex flex-col justify-center">
        <p class="text-[10px] text-[#006269] uppercase font-black tracking-widest mb-2 px-2 text-center">Filter By Month/Year</p>
        <div class="flex items-center gap-2 bg-gray-50 p-2 rounded-xl border border-gray-100">
            <div class="flex-1 rounded-2xl flex flex-col px-1 ">
              <label class="text-[12px] uppercase text-[#006269] font-black mb-1">From Date</label>
              <input type="date" [(ngModel)]="startDate" (change)="onSearch()" class="bg-transparent text-[11px] font-bold outline-none cursor-pointer border border-gray-300 rounded-xl px-2 py-1 appearance-none">
            </div>
            <div class="h-8 w-[1px] bg-gray-200"></div>
            <div class="flex-1 rounded-2xl flex flex-col px-1">
              <label class="text-[12px] uppercase text-[#006269] font-black mb-1">To Date</label>
              <input type="date" [(ngModel)]="endDate" (change)="onSearch()" class="bg-transparent text-[11px] font-bold outline-none cursor-pointer border border-gray-300 rounded-xl px-2 py-1 appearance-none"/>
            </div>
        </div>
      </div>
    </div>

    <!-- DATA TABLE -->
    <div class="bg-white rounded-2xl shadow-xl border border-gray-200 flex flex-col overflow-hidden">
      <div *ngIf="isLoading" class="h-1 bg-cyan-100 overflow-hidden shrink-0"><div class="h-full bg-[#006269] animate-progress w-full"></div></div>

      <div class="overflow-x-auto">
        <table class="w-full border-collapse text-left text-xs">
          <thead class="bg-gray-50 border-b border-gray-100 whitespace-nowrap">
            <tr>
              <th class="p-4 font-black text-gray-500 uppercase">Inv No</th>
              <th class="p-4 font-black text-gray-500 uppercase">Customer Name</th>
              <th class="p-4 font-black text-gray-500 uppercase">GSTIN</th>
              <th class="p-4 font-black text-gray-500 uppercase">PAN</th>
              <th class="p-4 font-black text-gray-500 uppercase">Mobile</th>
              <th class="p-4 font-black text-gray-500 uppercase">Mode</th>
              <th class="p-4 font-black text-gray-500 uppercase">Payment Reference</th>
              <th class="p-4 font-black text-gray-500 uppercase">Qty</th>
              <th class="p-4 font-black text-[#006269] uppercase">Grand Total</th>
              <th class="p-4 font-black text-gray-500 uppercase">Date</th>
              <th class="p-4 font-black text-gray-500 uppercase text-center">Actions</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-50 whitespace-nowrap">
            <tr *ngFor="let inv of paginatedInvoices" class="hover:bg-blue-50/40 transition-colors">
              <td class="p-4 font-bold text-cyan-700">{{ inv.invoice_no }}</td>
              <td class="p-4 font-bold text-gray-800 uppercase">{{ inv.customer_name }}</td>
              <td class="p-4 font-mono text-gray-600">{{ inv.customer_gstin || 'N/A' }}</td>
              <td class="p-4 font-mono uppercase">{{ inv.customer_pan || '---' }}</td>
              <td class="p-4 text-gray-600">{{ inv.customer_mobile }}</td>
              <td class="p-4 uppercase">{{ inv.payment_mode }}</td>
              <td class="p-4 uppercase">{{ inv.payment_reference || '-' }}</td>
              <td class="p-4 font-bold">{{ inv.quantity_per_gm }} gm</td>
              <td class="p-4 font-black text-[#006269] text-sm">₹{{ inv.grand_total | number:'1.2-2' }}</td>
              <td class="p-4">{{ inv.created_at | date:'dd - MMM - yyyy' }}</td>
              <td class="p-4">
                <div class="flex justify-center gap-2">
                  <button (click)="printInvoice(inv.id)" class="h-7 w-7 rounded-md bg-gray-100 text-gray-600 hover:bg-[#006269] hover:text-white transition-all"><i class="fas fa-print text-[10px]"></i></button>
                  <button (click)="deleteInvoice(inv.id)" class="h-7 w-7 rounded-md bg-red-50 text-red-400 hover:bg-red-600 hover:text-white transition-all"><i class="fas fa-trash-alt text-[10px]"></i></button>
                  <!-- <button (click)="sendPDFToWhatsapp(inv.customer_mobile,inv.customer_name)" class="h-7 w-7 rounded-md bg-red-50 text-red-400 hover:bg-red-600 hover:text-white transition-all"><i class="fab fa-whatsapp" style="font-size:25px; color:green;"></i></button> -->
                </div>
              </td>
            </tr>
            <tr *ngIf="paginatedInvoices.length === 0 && !isLoading">
              <td colspan="10" class="p-10 text-center text-gray-400 italic font-medium">No records found for the selected search or date range.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <footer class="h-14 border-t border-gray-100 bg-gray-50 flex items-center justify-between px-6 shrink-0">
        <p class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Showing {{ paginatedInvoices.length }} of {{ totalItems }} records</p>
        <div class="flex items-center gap-2">
          <button [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)" class="h-8 w-8 flex items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 hover:bg-[#006269] hover:text-white disabled:opacity-30 transition-all"><i class="fas fa-chevron-left text-[10px]"></i></button>
          <span class="px-4 text-[10px] font-black text-[#006269] uppercase">Page {{ currentPage }} / {{ lastPage }}</span>
          <button [disabled]="currentPage >= lastPage" (click)="goToPage(currentPage + 1)" class="h-8 w-8 flex items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 hover:bg-[#006269] hover:text-white disabled:opacity-30 transition-all"><i class="fas fa-chevron-right text-[10px]"></i></button>
        </div>
      </footer>
    </div>
  </main>
</div>